import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-integrations-home',
    templateUrl: './integrationshome.component.html',
    styleUrls: ['./integrationshome.component.scss'],
    standalone: false
})
export class IntegrationsHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
